import { Component } from '@angular/core';

@Component({
  selector: 'app-catalog-items',
  templateUrl: './catalog-items.component.html',
  styleUrls: ['./catalog-items.component.css'],
})
export class CatalogItemsComponent {}
